import { del, get, post, put } from './request'

interface AmenityService {
    supplier: string;
    propertyId: string;
    property: {
        amenityservice: Array<object>
    };
}


export const getAmenityservices = (supplier: string, propertyid: string) => get(`/property/amenityservice?supplier=${supplier}&propertyid=${propertyid}`)
export const addAmenityservice = (amenityService: AmenityService) => post('/property/amenityservice', amenityService)
export const updateAmenityservice = (amenityService: AmenityService) => put('/property/amenityservice', amenityService)
export const deleteAmenityservice = (amenityService: AmenityService) => del('/property/amenityservice', amenityService)

export const addSchedule = (amenityService: AmenityService) => post('/property/amenityservice/schedule', amenityService)
export const updateSchedule = (amenityService: AmenityService) => put('/property/amenityservice/schedule', amenityService)
export const deleteSchedule = (amenityService: AmenityService) => del('/property/amenityservice/schedule', amenityService)

export const addSecurity = (amenityService: AmenityService) => post('/property/amenityservice/security', amenityService)
export const updateSecurity = (amenityService: AmenityService) => put('/property/amenityservice/security', amenityService)
export const deleteSecurity = (amenityService: AmenityService) => del('/property/amenityservice/security', amenityService)